<template>
  <div class="manage" style="width: 100%" height="90%">

    <div class="top">
      <el-form :model="searchForm" :inline="true">
        <el-form-item>
          <el-input placeholder="请输入查询内容" v-model="searchForm.query"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>

      <el-button type="primary" style="height: 40px;" @click="handleUpdate">升级固件</el-button>
    </div>

    <el-table :data="tableData.result" :stripe="true">
      <el-table-column label="序号" prop="id" align="center" width="50"/>
      <el-table-column label="固件号" prop="firmware_version" align="center" width="120" />
      <el-table-column label="最低固件号" prop="min_firmware_version" align="center" width="120" />
      <el-table-column label="固件下载路径" prop="firmware_url" align="center" width="300" />
      <el-table-column label="固件日期" prop="version_date" align="center" width="200" />
      <el-table-column label="说明" prop="description" align="center" width="300" />
      <el-table-column label="强制更新" prop="is_force_updat" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.isActive">True</span>
          <span v-else>False</span>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="180">
        <template slot-scope="scope">
          <el-button @click="deleteRow(scope.$index, scope.row)" type="danger" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center;">
      <el-pagination layout="sizes, prev, pager, next"
        :total="tableData.total_items"
        :page-size="tableData.size"
        :page-count="tableData.total_pages"
        :page-sizes="[5, 10, 15, 20]"
        :current-page.sync = "tableData.page"
        @current-change = "handleCurrentChange"
        @size-change = "handleSizeChange">
      
      </el-pagination>
    </div>
  </div>
</template>

<script>
import http from '../utils/request'
export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        query: ''
      },
      // currentPage: this.$store.state.currentPage,
      pageSize: 5
    };
  },
  methods: {
    getFirmwares(page, size) {
      var url = 'https://test.chongyueyue.cn/smart_feeder/firmware/firmwares?page=' + page +'&size=' + size
      console.log('http url: ', url)
      return http.get(url, {
        headers: 'application/x-www-form-urlencoded; charset=UTF-8',
        withCredentials: false
      })
    },

    handleCurrentChange(page) {
      console.log('currentPage', page)
      this.getFirmwares(page, this.pageSize).then((resp) => {
        this.tableData = resp.data.data
        this.pageSize = this.tableData.size
      })
      // this.currentPage = val
      // this.$store.state.currentPage = val;
    },

    handleSizeChange(size) {
      console.log('current size: ', size)
      this.getFirmwares(1, size).then(resp => {
        this.tableData = resp.data.data
        this.pageSize = this.tableData.size
      })
    },

    handleSearch() {
      var query = this.searchForm.query
      console.log('query firmware key words: ', query)
    },

    handleUpdate() {
      this.$router.push('/feederupfw')
    },

    deleteRow(index, row) {
      console.warn('Deleting row:', row, 'index:', index)
      // this.tableData.splice(index, 1)
      this.$confirm("确定要删除固件版本号 " + row.firmware_version + " 吗?", "删除提示", {
        iconClass: "el-icon-question",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: true,
        type: "warning"
      }).then(res => {
        var fd = new FormData()
        fd.append('firmware_version', row.firmware_version)
        var config = {headers: {}, withCredentials: false}

        http.post('https://test.chongyueyue.cn/smart_feeder/firmware/delete_firmware',
          fd, config
        ).then(res => {
          if (res.data.code === 200) {
            this.$message({showClose: true, message: "删除成功！", type: "success", duration: 1000, center: true})
            
            this.handleCurrentChange(1)
          }
        })
      }).catch(() => {
        console.log('Cancelling Delete')
      })      
    }
  },
  mounted() {
    this.getFirmwares(1, this.pageSize).then((resp) => {
      this.tableData = resp.data.data
      this.pageSize = this.tableData.size
      console.log('table data: ', this.tableData)
    })
  }

  // onUnload() {},
  // 页面处理函数--监听用户下拉动作
  // onPullDownRefresh() { uni.stopPullDownRefresh(); },
  // 页面处理函数--监听用户上拉触底
  // onReachBottom() {},
  // 页面处理函数--监听页面滚动(not-nvue)
  // onPageScroll(event) {},
  // 页面处理函数--用户点击右上角分享
  // onShareAppMessage(options) {},
}
</script>

<style scoped></style>